import React, { useEffect } from 'react';

const DynamicFavicon = ({ logoUrl }) => {
  useEffect(() => {
    if (logoUrl) {
      const link = document.querySelector("link[rel~='icon']");
      if (link) {
        link.href = logoUrl;
      }
      
      const appleTouchIcon = document.querySelector("link[rel~='apple-touch-icon']");
      if (appleTouchIcon) {
        appleTouchIcon.href = logoUrl;
      }
    }
  }, [logoUrl]);

  return null;
};

export default DynamicFavicon; 